import { FollowTypes, QuestionType } from '@follow/cdk'

export type BaseAnswer = FollowTypes.Questionnaire.BaseAnswer
export type BaseQuestion = FollowTypes.Questionnaire.BaseQuestion
export type PercentageScoreConfig = FollowTypes.Questionnaire.PercentageScoreConfig
export type QuestionConfig = FollowTypes.Questionnaire.QuestionConfig
export type MinMaxScoreConfig = FollowTypes.Questionnaire.MinMaxScoreConfig
export type ScoreConfig = FollowTypes.Questionnaire.ScoreConfig
export type Questionnaire = FollowTypes.Questionnaire.Questionnaire
export type QuestionnaireTemplate = FollowTypes.Questionnaire.QuestionnaireTemplate
export type QuestionnaireInstance = FollowTypes.Questionnaire.QuestionnaireInstance
export type QuestionTemplate = FollowTypes.Questionnaire.QuestionTemplate
export type QuestionInstance = FollowTypes.Questionnaire.QuestionInstance
export type Question = FollowTypes.Questionnaire.Question
export type AnswerTemplate = FollowTypes.Questionnaire.AnswerTemplate
export type AnswerInstance = FollowTypes.Questionnaire.AnswerInstance
export type Answer = FollowTypes.Questionnaire.Answer

export { QuestionType }

export const QUESTION_TYPE_TO_LABEL: { [type in QuestionType]: string } = {
  SELECT: 'Liste',
  SLIDER: 'Slider',
  TEXT: 'Libre',
  YES_NO: 'QCU',
  RADIO: 'QCU',
  BTN_GROUP: 'QCU',
  BTN_GROUP_MULTIPLE: 'QCM',
  DATE: 'DATE',
}

export const WITH_ANSWERS_QUESTION_TYPES = [
  QuestionType.YesNo,
  QuestionType.Select,
  QuestionType.QCU,
  QuestionType.QCM,
  QuestionType.BtnGroup,
]
export const questionPlaceholder = {
  [QuestionType.Text]: 'Intitulé de la question (Texte libre)',
  [QuestionType.Slider]: 'Intitulé de la question (Slider)',
  [QuestionType.YesNo]: 'Intitulé de la question (Oui / Non)',
  [QuestionType.QCU]: 'Intitulé de la question (QCU)',
  [QuestionType.QCM]: 'Intitulé de la question (QCM)',
  [QuestionType.Date]: 'Intitulé de la question (Date)',
}

export const subQuestionPlaceholder = {
  [QuestionType.Text]: 'Intitulé de la sous-question (Texte libre)',
  [QuestionType.Slider]: 'Intitulé de la sous-question (Slider)',
  [QuestionType.YesNo]: 'Intitulé de la sous-question (Oui / Non)',
  [QuestionType.QCU]: 'Intitulé de la sous-question (QCU)',
  [QuestionType.QCM]: 'Intitulé de la sous-question (QCM)',
  [QuestionType.Date]: 'Intitulé de la sous-question (Date)',
}

export const QuestionLevel = {
  Question: 'Question',
  SubQuestion: 'Sous-question',
}

export interface QuestionnaireWithAnswerValues extends Omit<QuestionnaireInstance, 'questions'> {
  questions: ReadonlyArray<QuestionInstance>
}

export interface QuestionnaireInstanceWithScore extends QuestionnaireInstance {
  scoreConfig: null
  scoreValue: undefined
}

export interface QuestionnaireInstanceScore extends QuestionnaireInstance {
  scoreConfig: ScoreConfig
  scoreValue: number | null
}

export interface WithFilledIndicatorQuestionnaireInstance extends QuestionnaireInstance {
  isFilled: boolean
}

export interface ScorePoint {
  scoreId: number
  documentId: number
  points: number | null
}

export type AnswerTemplateLight = SafeOmit<AnswerTemplate, 'childQuestions'> & {
  childQuestionIds?: number[]
}

export interface LightQuestionnaire extends Omit<Questionnaire, 'questions'> {}

export type AnswerInstanceLight = SafeOmit<AnswerInstance, 'childQuestions'> & {
  childQuestionIds?: number[]
}

export interface QuestionInstanceLight extends BaseQuestion {
  answers: AnswerInstanceLight[]
}

export interface QuestionnaireUpdateForm {
  scoreConfig?: ScoreConfig | null
  tagIds?: ReadonlyArray<string>
  title?: string
  private?: boolean
}

export interface LightQuestionnaireTemplate
  extends Omit<QuestionnaireTemplate, 'questionTemplates'> {}

export enum QuestionEditionOrigin {
  TEMPLATE = 'template',
  QUESTIONNAIRE = 'questionnaire',
  MEDICAL_EVENT = 'medicalEvent',
  NONE = 'none',
}
